var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_vm._t("actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }